import React, { useMemo } from 'react'
import {
  DropDownButtonComponent,
  ItemModel,
  MenuEventArgs,
} from '@syncfusion/ej2-react-splitbuttons'
import { IPhases, ITreatmentPlan } from '@dataTypes/treatmentPlan.types'
import './PhaseActionMenuButton.css'

interface PhaseActionMenuButtonProps {
  tabKey: string
  originalIdx: number
  phase: IPhases
  plan: ITreatmentPlan | null
  isEditMode: boolean
  canMoveUp?: boolean
  canMoveDown?: boolean
  onMenuSelect: (
    args: MenuEventArgs,
    tabKey: string,
    originalIdx: number,
    phase: IPhases,
    plan: ITreatmentPlan | null,
    isEditMode: boolean,
  ) => void
  customMenuItems?: ItemModel[]
}

const createPhaseMenuItems = (
  canMoveUp: boolean,
  canMoveDown: boolean,
): ItemModel[] => [
  {
    text: 'Move up',
    id: 'move-phase-up',
    disabled: !canMoveUp,
  },
  {
    text: 'Move down',
    id: 'move-phase-down',
    disabled: !canMoveDown,
  },
  {
    text: 'Duplicate',
    id: 'duplicate',
  },
  {
    text: 'Delete',
    id: 'delete',
  },
]

const PhaseActionMenuButton: React.FC<PhaseActionMenuButtonProps> = ({
  tabKey,
  originalIdx,
  phase,
  plan,
  isEditMode,
  canMoveUp = false,
  canMoveDown = false,
  onMenuSelect,
  customMenuItems,
}): JSX.Element => {
  const handleSelect = (args: MenuEventArgs): void => {
    onMenuSelect(args, tabKey, originalIdx, phase, plan, isEditMode)
  }

  const handleBeforeItemRender = (args: MenuEventArgs): void => {
    if (args.item?.id === 'delete') {
      if (args.element) {
        args.element.classList.add('delete-menu-item')
        args.element.style.color = 'var(--red-500)'
      }
    }
  }

  const menuItems = useMemo(() => {
    if (customMenuItems) {
      return customMenuItems
    }
    return createPhaseMenuItems(canMoveUp, canMoveDown)
  }, [customMenuItems, canMoveUp, canMoveDown])

  return (
    <div className="phase-action-menu-container">
      <DropDownButtonComponent
        items={menuItems}
        iconCss="ti ti-dots-vertical"
        cssClass="e-caret-hide phase-action-dropdown-btn"
        select={handleSelect}
        beforeItemRender={handleBeforeItemRender}
      />
    </div>
  )
}

export default PhaseActionMenuButton
